import API from "./api";

// ✅ Get all employees
export const getEmployees = async () => {
    try {
        const response = await API.get("/employees");
        return response.data;
    } catch (error) {
        console.error("Error fetching employees:", error);
        throw error;
    }
};

// ✅ Register a new employee
export const registerEmployee = async (employeeData) => {
    try {
        // Ensure status_id is set to 1 (Active) by default
        const employeePayload = { ...employeeData, statusId: 1 };

        const response = await API.post("/employees/register", employeePayload, {
            headers: { "Content-Type": "application/json" }
        });

        return response.data;
    } catch (error) {
        console.error("Error registering employee:", error);
        throw new Error(error.response?.data?.message || "Server error");
    }
};

// ✅ Update employee status
export const updateEmployeeStatus = async (nic, newStatus) => {
    try {
        const response = await API.put(`/employees/update/${nic}`, {
            status_id: parseInt(newStatus) // ✅ Convert status to integer if required
        }, {
            headers: { "Content-Type": "application/json" } // ✅ Ensure JSON headers
        });
        return response.data;
    } catch (error) {
        console.error(`Error updating employee (${nic}):`, error);
        throw new Error(error.response?.data?.message || "Server error");
    }
};
// ✅ Create a new role with error handling
export const createRole = async (roleData) => {
    try {
        const response = await API.post("/roles/add-role", roleData);
        return response.data;
    } catch (error) {
        console.error("Error creating role:", error.response?.data || error.message);
        throw error;
    }
};
